<template>
    <div>
        <div v-show="siteIsLoaded">
            <div v-show="!bookingFinishedSuccessful">
                <div class="event-registration-main">
                    <Notifications />
                    <div class="main-grid">
                        <div class="navigation-shadow" />
                        <div class="registration-header-shadow" />
                        <div class="registration-header px-4">
                            <h1
                                v-if="siteData"
                                class="flex-grow-1">
                                <font-awesome-icon
                                    v-if="siteData.internal"
                                    class="mr-2"
                                    icon="lock" />
                                {{ siteData.title }}
                            </h1>
                            <div class="py-2 px-3">
                                <div class="d-flex gap-2 align-items-center">
                                    <BasePopover
                                        v-if="siteData?.documents?.length"
                                        placement="bottom-end"
                                        trigger="hover">
                                        <template #reference>
                                            <font-awesome-icon
                                                fixed-width
                                                class="pointer"
                                                size="2x"
                                                icon="folder-open" />
                                        </template>
                                        <div
                                            class="m--3"
                                            style="max-height: 90vh; overflow-y: auto; overflow-x: hidden">
                                            <DocumentList />
                                        </div>
                                    </BasePopover>
                                    <EmployeeHint />
                                    <BasePopover
                                        placement="bottom-end"
                                        trigger="hover">
                                        <template #reference>
                                            <BookingCart />
                                        </template>
                                        <div style="max-height: 90vh; overflow-y: auto; overflow-x: hidden">
                                            <BookingList />
                                        </div>
                                    </BasePopover>
                                </div>
                            </div>
                        </div>
                        <div class="navigation">
                            <div class="my-3 mx-2">
                                <RegistrationMenu />
                            </div>
                            <div class="flex-grow-1" />
                            <AnbieterLogo class="logo-desktop" />
                        </div>
                        <div class="main-wrapper">
                            <div class="main">
                                <NuxtPage />
                            </div>
                            <div class="flex-grow-1" />
                            <div class="main-footer">
                                <Impressum />
                            </div>
                        </div>
                    </div>
                    <MobileFooter class="registration-footer" />
                </div>
            </div>
            <SuccessFinishPage v-if="bookingFinishedSuccessful" />
        </div>
        <div v-show="!siteIsLoaded">
            <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100vh">
                <font-awesome-icon
                    icon="circle-notch"
                    spin
                    size="8x"
                    class="text-primary" />
            </div>
        </div>
    </div>
</template>
<script>
import AnbieterLogo from "@/components/layouts/onlineBooking/AnbieterLogo";
import RegistrationMenu from "@/components/layouts/onlineBooking/RegistrationMenu";
import MobileFooter from "@/components/layouts/onlineBooking/MobileFooter";
import SuccessFinishPage from "@/components/layouts/SuccessFinishPage";
import mainSiteMixin from "@/mixins/mainSiteMixin";
import BookingCart from "@/components/layouts/onlineBooking/BookingCart";
import BookingList from "@/components/farbcode-core/BookingList";
import EmployeeHint from '../components/layouts/onlineBooking/EmployeeHint'

export default {
    components: {
        EmployeeHint,
        BookingList,
        BookingCart,
        SuccessFinishPage,
        MobileFooter,
        RegistrationMenu,
        AnbieterLogo
    },
    mixins: [mainSiteMixin]

}
</script>

<style lang="scss" scoped>
@use "sass:map";


.main-grid {
    display: grid;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    grid-template-columns: $registration-navigation-width auto;
    grid-template-rows: $registration-header-height auto;
    grid-template-areas: "main main" "main main";
}

.registration-footer {
    display: block;
    z-index: 2;
}

:deep(.el-popover) {
    padding: 0;
}

@include media-breakpoint-down(sm) {
    .main-grid > :not(.main-wrapper) {
        display: none;
    }
}

@include media-breakpoint-up(md) {
    .registration-footer {
        display: none;
    }
    .main-grid {
        grid-template-areas: "header header" "navigation main";
    }
}


.navigation-shadow, .registration-header-shadow {
    box-shadow: $box-shadow;
    background: $white;
}

.navigation-shadow {
    grid-area: navigation;
}

.registration-header-shadow {
    grid-area: header;
}

.registration-header {
    grid-area: header;
    display: flex;
    align-items: center;
    background: $white;
}

.navigation {
    grid-area: navigation;
    display: flex;
    flex-direction: column;
    background: $white;
}

.price-box {
    box-shadow: $box-shadow;
    background: $white;
}

.main-wrapper {
    overflow: auto;
    grid-area: main;
    display: flex;
    flex-direction: column;
}

.main {
    margin: map.get($spacers, 3) map.get($spacers, 4) calc(#{map.get($spacers, 3)} + #{$registration-mobile-footer-height-closed}) map.get($spacers, 4);

    @include media-breakpoint-up(md) {
        margin: map.get($spacers, 4);
    }
}


.logo-desktop {
    height: calc(#{$registration-navigation-width} - #{$registration-navigation-width} / 2);
    width: calc(#{$registration-navigation-width} - #{$registration-navigation-width} / 2);
    margin: map.get($spacers, 2) auto;
}

.main-footer {
    display: flex;
    justify-content: flex-end;
    margin: map.get($spacers, 3) map.get($spacers, 4) calc(#{map.get($spacers, 3)} + #{$registration-mobile-footer-height-closed}) map.get($spacers, 4);

    @include media-breakpoint-up(md) {
        margin: map.get($spacers, 4);
    }
}


</style>
